import { createSlice } from "@reduxjs/toolkit";
import { getClasses } from "./_classesAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const classesList = createSlice({
  name: "classesList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getClasses.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getClasses.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage;
        state.responseCode = payload.responseCode;
        state.totalRecord = payload.totalRecord || 0;        
      })
      .addCase(getClasses.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
